import { grey } from "@mui/material/colors";

const styles = {
  backdrop: {
    color: "#fff",
    zIndex: 9999,
    position: "absolute",
    borderRadius: 2,
  },
  card: {
    maxWidth: 600,
    mt: 3,
    border: "1px solid",
    borderColor: grey[200],
    borderRadius: 2,
  },
  cardContent: {
    p: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  description: {
    mb: 3,
    lineHeight: 1.6,
  },
};

export default styles;
